import Counselor from '@/models/Counselor';
import Organisation from '@/models/Organisation';
import TrajectoryState from '@/models/TrajectoryState';

const LOAD_TRAJECTORY_RESOURCES = 'load_trajectory_resources';

const LOAD_TRAJECTORY_RESOURCES_REQUEST = 'load_trajectory_resources_request';
const LOAD_TRAJECTORY_RESOURCES_SUCCESS = 'load_trajectory_resources_success';
const LOAD_TRAJECTORY_RESOURCES_ERROR = 'load_trajectory_resources_error';


let FINISHED_STATES_CODES = ['completed_internal', 'completed_external_inside_sector', 'completed_external_outside_sector', 'completed_without_placement'];


export { LOAD_TRAJECTORY_RESOURCES, FINISHED_STATES_CODES };
/**
 * Loads and store the trajectory-specific global data:
 * trajectory_states: the possible value for the trajectory state
 * counselors: counselors registered in the system
 * organisations: organisations registered in the system
 */
export default {
    state: {
        loading: false,
        trajectory_states: [],
        counselors: [],
        organisations: []
    },
    mutations: {
        [LOAD_TRAJECTORY_RESOURCES_REQUEST] (state) {
            state.loading = true;
        },
        [LOAD_TRAJECTORY_RESOURCES_SUCCESS] (state, { trajectory_states, counselors, organisations }) {
            state.loading = false;
            state.trajectory_states = trajectory_states;
            state.counselors = counselors;
            state.organisations = organisations;
        },
        [LOAD_TRAJECTORY_RESOURCES_ERROR] (state, errors) {
            state.loading = false;
        }
    },
    actions: {
        [LOAD_TRAJECTORY_RESOURCES] ({ commit, state }) {
            commit(LOAD_TRAJECTORY_RESOURCES_REQUEST);

            let trajectory_statesPromise = TrajectoryState.collection();
            let counselorsPromise = Counselor.collection();
            let organisationsPromise = Organisation.collection();

            Promise.all([trajectory_statesPromise, counselorsPromise, organisationsPromise])
                .then(values => {
                    commit(LOAD_TRAJECTORY_RESOURCES_SUCCESS, {
                        trajectory_states: values[0].items,
                        counselors: values[1].items,
                        organisations: values[2].items,
                    });
                }).catch(({ status, errors }) => {
                    commit(LOAD_TRAJECTORY_RESOURCES_ERROR, errors);
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/trajectory-resources.js